import React from "react";
import Accordion from "components/Accordion";

export interface Props<T> {
  rootRef: React.RefObject<HTMLElement>;
  isFetching: boolean;
  totalResults: number;
  activeCount: number;
  items: T[];
  title: string;
  children: React.ReactNode;
}

function CollapsibleList<T>(props: Props<T>) {
  const {
    rootRef,
    isFetching,
    totalResults,
    activeCount,
    children,
    title,
    items
  } = props;

  return (
    <>
      <Accordion
        count={activeCount ? activeCount : totalResults}
        name={title}
        rootRef={rootRef}
        disabled={(!items?.length && !isFetching) || isFetching}
        isLoading={isFetching}
        hideSubtitleWhenCollapsed
        alert={Boolean(activeCount)}
      >
        {children}
      </Accordion>
    </>
  );
}

export default CollapsibleList;
